import axios from "axios";

export default axios.create({baseURL:'https://quickcart-backend-xuv8.onrender.com'})